
import { FunctionComponent, useEffect, useState } from 'react';
import styles from "./Login.module.css";
import {Image, Form} from 'react-bootstrap';
import cn from 'classnames';
import AuthLayout from '../../../component/common/Layout/AuthLayout/AuthLayout';
import FormField, { IFieldType } from '../../../component/common/FormField/FormField';
import { Link } from 'react-router-dom';
import { PageRoutes } from '../../../routing/paths';
import { useNavigate } from "react-router-dom";
import { ASSESTS } from '../../../constant/assest';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../../redux/slices/auth/actions';
import { clearError, clearMessage, setTempPassword } from '../../../redux/slices/auth/slice';
import { RootState, AppDispatch } from '../../../redux/store';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { loginSchema } from '../../../validation/authValidation';

const Login: FunctionComponent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { isAuthenticated, loading, error, message } = useSelector((state: RootState) => state.auth);
    const [keepMeSignedIn, setKeepMeSignedIn] = useState(false);
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: loginSchema,
        onSubmit: values => {
            dispatch(setTempPassword(values.password));
            dispatch(login({ email: values.email, password: values.password, keepMeSignedIn }));
        },
    });

    const handleBlurWithTrim = (e: React.FocusEvent<HTMLInputElement>) => {
        formik.handleBlur(e); // for touched state
        const { name, value } = e.target;
        const trimmedValue = value.trim();

        if (value !== trimmedValue) {
            // Create a fake change event to update the value via formik.handleChange
            const fakeChangeEvent = {
                target: {
                    name: name,
                    value: trimmedValue,
                },
            };
            formik.handleChange(fakeChangeEvent);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            navigate(PageRoutes.DASHBOARD);
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        if (message) {
            toast.success(message);
            dispatch(clearMessage());
            navigate(PageRoutes.OTPVERIFY, { state: { email: formik.values.email } });
        }
    }, [message, navigate, formik.values.email, dispatch]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearError());
        }
    }, [error, dispatch]);

    return (
        <AuthLayout>
            <div className={styles.logo}>
                <Image 
                    src={ASSESTS.LOGO}
                    width={291}
                    height={73}
                    alt="Fishinity"
                />
            </div>
            <div className={styles.header}>Welcome</div>
            <form onSubmit={formik.handleSubmit} className={styles.form}>
                <FormField 
                    label='Email'
                    placeholder='Enter Email Address'
                    fieldType={IFieldType.EMAIL} 
                    className={styles.mb4}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={handleBlurWithTrim}
                    errorText={formik.errors.email}
                    showError={!!(formik.touched.email && formik.errors.email)}
                />
                <FormField 
                    label='Password'
                    placeholder='Enter Password'
                    fieldType={IFieldType.PASSWORD}
                    showEyeIcon={true}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={handleBlurWithTrim}
                    errorText={formik.errors.password}
                    showError={!!(formik.touched.password && formik.errors.password)}
                />
                <div className={cn(styles.checkboxWrap)}>
                    <Form.Check
                        type={'checkbox'}
                        label={'Keep me signed in'}
                        className={styles.checkbox}
                        id={'keep-me-signed-in'}
                        checked={keepMeSignedIn}
                        onChange={(e) => setKeepMeSignedIn(e.target.checked)}
                    />
                </div>
                <div className={cn(styles.submit, styles.mb4)}>
                    <button 
                        type="submit"
                        className='customBtn greenBtn'
                        disabled={loading === 'pending'}
                    >
                        {loading === 'pending' ? 'Logging in...' : 'Login'}
                    </button>
                </div>
                 <div className={styles.register}>
                    <Link to={PageRoutes.FORGOTPASSWORD} className={styles.link}>Forgot your password?</Link>
                </div>
            </form>
        </AuthLayout>
    );
};

export default Login;